export default __webpack_public_path__ + "static/media/g.65f9a3cf.svg";